define.alias("shared/components/shared/post/secondary/caption-writer/info-modal", "media/components/shared/post/secondary/caption-writer/info-modal");